import './JiraSummary.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getInitiativeJiraIssuesSelector } from '../../@arch/selectors';
import { integrationsActions } from '@sonar-software/sonar-integrations';
import { JiraIcon } from '@ui/icons';
import { JiraIssue } from './JiraIssue';
import { PostJiraIssueSyncNotifications } from '../../notifications';
import { SonarText } from '@ui/text';
import React, { useCallback } from 'react';
import { useAction, useInterval, useOnMount, useSonarSelector } from '@hooks';

export interface JiraSummaryProps {
	initiativeId: number;
}

export const JiraSummary: React.FC<JiraSummaryProps> = ({ initiativeId }) => {
	const getInitiativesJiraIssues = useAction(integrationsActions.requestGetInitiativeJiraIssues);
	const getJiraSummary = useAction(integrationsActions.requestGetJiraSummary);

	const refreshInitiativeJiraIssues = useCallback(() => {
		getInitiativesJiraIssues({
			initiativeId
		});
	}, [ getInitiativesJiraIssues, initiativeId ]);

	useOnMount(() => {
		refreshInitiativeJiraIssues();
		getJiraSummary();
	});

	useInterval(refreshInitiativeJiraIssues, 10000);

	const jiraIssueData = useSonarSelector(getInitiativeJiraIssuesSelector.data);

	const jiraIssues = jiraIssueData?.map((jiraIssue) => {
		const { issueName, issueKey, issueStatusId, isSynced, projectKey } = jiraIssue;

		return (
			<JiraIssue
				initiativeId={ initiativeId }
				issueKey={ issueKey }
				issueName={ issueName }
				isSynced={ isSynced }
				key={ issueKey }
				projectKey={ projectKey }
				statusId={ issueStatusId }
				summary />
		);
	});

	if (!jiraIssueData?.length) {
		return null;
	}

	return (
		<div className='jira-issues-summary'>
			<PostJiraIssueSyncNotifications />
			<div className='summary-label'>
				<JiraIcon className='jira-icon' />
				<SonarText
					className='summary-title'
					size={ 16 }
					strong>
					{ COPY_SPECIFIC.JIRA_ISSUES }
				</SonarText>
			</div>
			{ jiraIssues }
		</div>
	);
};
